import { render, staticRenderFns } from "./Backdoor.vue?vue&type=template&id=10fb4395&"
import script from "./Backdoor.vue?vue&type=script&lang=js&"
export * from "./Backdoor.vue?vue&type=script&lang=js&"
import style0 from "./Backdoor.vue?vue&type=style&index=0&id=10fb4395&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports